import React from 'react'

import Projects from '../../components/Projects/Projects'
import Skills from '../../components/Skills/Skills'

const ProjectsPage = () => (
    <div id='projects-page'>
      <Projects />
      <Skills />
    </div>
)

export default ProjectsPage
